module.exports = __webpack_public_path__ + "static/media/pay-visa-on.384bcc52.png";